export default {
  payments: 'Платежи',
  revenue: 'ВЫРУЧКА',
  profit: 'ВПН',
  sku: 'SKU',
  clientsShipped: 'Отгружено клиентов',
  markup: 'Наценка',
  limit: 'ДЗ лимит',
  fact: 'ДЗ факт',
  free: 'Свободно',
  pdz: 'ПДЗ',
  profitYesterday: 'ВПН ЗА ВЧЕРА',
  costProfit: 'ССВПН',
  changeProgit: 'ИЗМ. ВПН',
  salary: 'ЗАРПЛАТА НА СЕГОДНЯ',
  pdzDay: 'ПДЗ В ДНЯХ',
  kLimit: 'k ЛИМИТА',
  VP: 'ВП',
  fillPlans: 'Заполнить планы',
  savePlans: 'Сохранить планы',
  plansForMonth: 'Планы на месяц',
  enterVP: 'Введите ВП',
  enterRevenue: 'Введите выручку',
  untilClosing: 'До закрытия',
};
